<!-- eslint-disable -->
<template lang="pug">
    olympiad-box.stage-waiting
        .stage-waiting__container(slot="top")
            img.stage-waiting__image(:src="WAITING_TURTLE")
            span.stage-waiting__text
                slot
</template>

<script>
    /*eslint-disable*/
    import OlympiadBox from './Box.vue'
    import WAITING_TURTLE from '../../assets/images/WaitingTurtle.svg';

    export default {
        data () {
            return {
                WAITING_TURTLE
            }
        },
        components: {
            OlympiadBox
        }
    }
</script>

<style lang="scss" scoped>
    .stage-waiting {
        &__container {
            position: relative;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            justify-content: center;
        }

        &__image {
            max-height: 190px;
            @include stack-space($space-small);
            @include media($sm) {
                max-height: 400px;
                @include stack-space(0)
            }
        }

        &__text {
            color: $color-brown-500;
            flex: auto;
            @include stack-space($space-base);
            text-align: center;
            @include media($sm) {
                flex: 1;
                @include stack-space(0);
            }
        }
    }
</style>
